import { useForm } from "react-hook-form";
import { Image, Form, Button, Alert } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import InputField from "../../molecules/FormItems/InputField";
import InputPassword from "../../molecules/FormItems/InputPassword";
import { login } from "./ducks/services";
import { AxiosError } from "axios";
import LoginTemplate from "../../templates/LoginTemplate";
import { useAppDispatch } from "../../config/hooks";
import { getUserDetails } from "../MyAccount/ducks/actions";
import { useState } from "react";
import { SuccessIcon } from "../../atoms/CustomIcons";
import ErrorMessage from "../../atoms/Toasts/ErrorMessage";

export default function Login() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const clearState = () => {
    navigate({ pathname: window.location.pathname }, { replace: true });
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (val: any) => {
    setLoading(true);
    login(val)
      .then((res: any) => {
        if (res?.data?.success) {
          localStorage.setItem("@fpToken", JSON.stringify(res?.data?.token));

          dispatch(getUserDetails())
            .then(() => {
              window.location.assign("/");
              setLoading(false);
            })
            .catch((e: unknown) => {
              if (e instanceof AxiosError) {
                setLoading(false);
                ErrorMessage(
                  e?.response?.data?.error?.message ?? "Something went wrong"
                );
              } else {
                setLoading(false);
                ErrorMessage("Something went wrong");
              }
            });
        }
      })
      .catch((e: unknown) => {
        setLoading(false);
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          ErrorMessage("Something went wrong");
        }
      });
  };
  console.log("App Version 1.4.9");
  return (
    <LoginTemplate loading={loading}>
      <div className="loginForm">
        <div className="loginLogo">
          <Image
            src="/images/login/fp_logo.svg"
            // width={48}
            // height={48}
            alt="Logo"
            preview={false}
          />
        </div>

        <h1> Welcome to Flower Power </h1>
        <p> Enter your account credentials to get started. </p>

        {location?.state?.name === "reset" && (
          <div className="alertWrapper">
            <Alert
              message="A link to reset your password has been emailed to you."
              icon={<SuccessIcon />}
              type="success"
              onClose={clearState}
              showIcon
              closable
            />
          </div>
        )}

        {location?.state?.name === "update" && (
          <div className="alertWrapper">
            <Alert
              message="Your password was reset. You can log in using your new password"
              icon={<SuccessIcon />}
              type="success"
              onClose={clearState}
              showIcon
              closable
            />
          </div>
        )}

        <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
          <InputField
            fieldName="email"
            label="Email"
            control={control}
            className="requiredInput"
            initValue=""
            iProps={{
              placeholder: "Enter email",
              autoComplete: "Email",
            }}
            isRequired
            rules={{
              required: "Email is required.",
              pattern: {
                value:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "Incorrect email address.",
              },
            }}
            validate={errors.email && "error"}
            validMessage={errors.email && errors.email.message}
          />
          <InputPassword
            fieldName="password"
            label="Password"
            control={control}
            className="requiredInput"
            initValue=""
            iProps={{
              placeholder: "Enter password",
              autoComplete: "Password",
            }}
            isRequired
            rules={{
              required: "Password is required.",
            }}
            validate={errors.password && "error"}
            validMessage={errors.password && errors.password.message}
          />
          <div className="forgotPass">
            <Link to="/forgot-password"> I forgot my password </Link>
          </div>
          <Button
            htmlType="submit"
            type="primary"
            className="primaryButton loginBtn"
          >
            Log In
          </Button>
          <div className="cantLogin">
            <p>
              Can't log in? Please, contact our{" "}
              <a href="mailto:support@flowerpower.software">Support team.</a>
            </p>
          </div>
        </Form>
        <div className="loginFooter">
          <a href="https://darkhorsesolutions.co/" target="_blank">
            <Image
              src="/images/login/dhs_logo.svg"
              alt="Logo"
              preview={false}
              style={{ width: "160px", height: "auto" }}
            />
          </a>
        </div>
      </div>
    </LoginTemplate>
  );
}
